import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/admin` has no content of its own; Users is the landing tab. */
export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/users' });
  },
});
